<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
      <template #footerShort>
        <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] justify-between">
          <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] md:items-end -md:order-2">
            <div>
              <AtomButtonDropdown :items="direction" />
            </div>
            <div>
              <AtomButtonDropdown :items="clubItems" />
            </div>
          </div>
          <AtomButton class="self-end -md:order-1 -md:w-full" to="/timetable">РАСПИСАНИЕ</AtomButton>
        </div>
      </template>
    </SectionHero>
    <SectionDefault>
      <Accordion />
      <Builder :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
import AtomButton from '../../components/atoms/AtomButton'
import AtomButtonDropdown from '../../components/atoms/AtomButtonDropdown'
import Builder from '../../components/builder/Builder'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import Accordion from '../../components/templates/fitness/mini-group/Accordion'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'mini-group',
})

export default {
  name: 'MiniGroup',
  components: {
    AtomButton,
    SectionDefault,
    SectionHero,
    OrganismHero,
    AtomButtonDropdown,
    Accordion,
    Builder,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'Мини-',
        title2: 'группы',
        image: 'fitness/mini-group/hero.webp',
        imageWrap: 'img-border-0',
        imageMobile: 'fitness/mini-group/hero-mobile.webp',
        breadcrumbs: c.$breadcrumbs.miniGroup(),
      },
      direction: [{ text: 'Москва' }, { text: 'Москва 2' }],
      clubItems: [{ text: 'ENCORE СИТИ' }, { text: 'ENCORE СИТИ 2' }],
    }
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'Мини-группы',
            description: 'Тренировки в малых группах с персональным подходом к каждому участнику.',
            provider: {
              '@type': 'Organization',
              name: 'Encore Fitness',
              url: 'https://encorefitness.ru/',
            },
          },
        },
      ],
    }
  },
}
</script>
